<template>
  <div v-if="isViewNotifications">
    <b-card no-body>

      <div class="m-2">
        <b-row>
          <b-col cols="12" md="6"></b-col>
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input v-model="searchQuery" @input="fetchNotifications" placeholder="Search..." class="mr-1" />

              <AddNotifications :manage="isAddNotifications" :token="bearerToken" :notificationTypes="notification_type"
                :edit-record="record" :is-editing-parent="isEditing" :editing-id-parent="editingId"
                @fetchNotifications="fetchNotifications" />
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table :items="pushNotification.data || []" :fields="tableFields" responsive small show-empty
        empty-text="No data available">

        <template #cell(index)="data">
          {{ (pushNotification.current_page - 1) * pushNotification.per_page + data.index + 1 }}
        </template>

        <template #cell(title)="data">
          {{ data.item.title }}
        </template>

        <template #cell(img)="data">
          <img v-if="data.item.mascort" :src="data.item.mascort" height="20" style="object-fit: contain" />
        </template>

        <template #cell(message)="data">
          <span style="display:inline-block; max-width:300px; white-space:normal; word-break:break-word;">
            {{ data.item.message }}
          </span>
        </template>
        <template #cell(target)="data">
          <span>
            <template v-if="data.item.targetType === 'all'">
              All Users
            </template>
            <template v-else-if="data.item.targetType === 'active-users'">
              Active Users ({{ formatActiveDuration(data.item.activeDuration) }})
            </template>
            <template v-else-if="data.item.targetType === 'class'">
              Specific Class ({{ getClassName(data.item.targetClassId || data.item.selectedClass) }})
            </template>
            <template v-else-if="data.item.targetType === 'specific_users'">
              Specific Users
            </template>
            <template v-else-if="data.item.targetType === 'specific_country'">
              Specific Country ({{ data.item.country || '-' }})
            </template>
            <template v-else>
              -
            </template>
          </span>
        </template>


        <template #cell(scheduledAt)="data">
          <span v-if="data.item.scheduledAt">
            {{ getScheduleStatusText(data.item) }}
          </span>
          <span v-else>-</span>
        </template>


        <template #cell(status)="data">
          Pending: {{ (data.item.statusCount && data.item.statusCount.pending) || 0 }}<br>
          Success: {{ (data.item.statusCount && data.item.statusCount.success) || 0 }}<br>
          Failed:
          <span class="">
            {{ (data.item.statusCount && data.item.statusCount.failed) || 0 }}
          </span>

          <feather-icon v-if="data.item.statusCount && data.item.statusCount.failed > 0" icon="EyeIcon"
            class="cursor-pointer" @click="viewFailedDetails(data.item._id)" style="margin-left: 5px;" />
        </template>


        <template #cell(history)="data">
          {{ data.item.recipientsCount }}
        </template>

        <template #cell(actions)="data">
          <b-dropdown right variant="link" toggle-class="text-dark p-0" no-caret>

            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" class="cursor-pointer" />
            </template>

            <b-dropdown-item @click="editNotification(data.item)">
              <feather-icon icon="EditIcon" class="mr-1" /> Edit
            </b-dropdown-item>
            <b-dropdown-item @click="deleteNotification(data.item)">
              <feather-icon icon="TrashIcon" class="mr-1" /> Delete
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>

      <b-modal id="failed-detail-modal" size="xl" title="Failed Notification Details" hide-footer>
        <b-table :items="failedUsers" :fields="['userId', 'profileId', 'status', 'fcmResponse']" small responsive
          show-empty empty-text="No failed users found" />
      </b-modal>


      <div class="mx-2 mt-2 mb-2 d-flex justify-content-between">
        <pagination :data="pushNotification" :limit="10" @pagination-change-page="fetchNotifications" />
      </div>
    </b-card>
  </div>
</template>


<script>
import {
  BCard, BRow, BCol, BFormInput, BModal, BButton, BTable, BDropdownItem,
  BDropdown,
} from "bootstrap-vue";
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    AddNotifications: () =>
      import("@/views/components/notifications/customNotifications/AddNotification.vue"),
    ToastificationContent,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BModal,
    BButton,
    BTable,
    BDropdownItem,
    BDropdown,

  },
  data() {
    return {
      isAddNotifications: false,
      isViewNotifications: false,
      searchQuery: "",
      classOptions: [],
      show: false,
      bearerToken: "",
      failedUsers: [],
      pushNotification: [],
      notification_type: [],
      notifications: [],
      record: null,
      isEditing: false,
      editingId: null,
      tableFields: [
        { key: 'index', label: '#', sortable: false },
        { key: "title", label: "Title", sortable: false },
        { key: "img", label: "Image", sortable: false },
        { key: "message", label: "Message", sortable: false },
        { key: "target", label: "Target", sortable: false },
        { key: 'scheduledAt', label: 'Scheduled Time' },
        { key: "status", label: "Status Counts", sortable: false },
        { key: "history", label: "Recipients Count", sortable: false },
        { key: 'actions', label: 'Actions' }
      ],
    };
  },
  mounted() {
    const permission = JSON.parse(localStorage.getItem("permission"))?.permission || [];
    this.isAddNotifications = permission.includes("add_app_push_notifications");
    this.isViewNotifications = permission.includes("view_app_push_notifications");

    this.bearerToken = "Bearer " + localStorage.getItem("_t");

    this.fetchNotifications();
    this.getAllGrades();
  },
  methods: {

    async getAllGrades() {
      try {
        const res = await axios.get(
          process.env.VUE_APP_API_URL + "/get-all-grades",
          {
            headers: {
              Authorization: this.bearerToken,
            },
          }
        );
        this.classOptions = res.data;
      } catch (error) {
        console.error("❌ Error fetching classes:", error);
      }
    },



    formatActiveDuration(duration) {
      if (!duration) return '-';

      const mapping = {
        today: 'Today',
        yesterday: 'Yesterday',
        this_month: 'This Month',
        last_month: 'Last Month',
        this_year: 'This Year',
      };
      return mapping[duration] || duration;
    },

    getClassName(classId) {
      console.log("Getting class name for I", classId);
      console.log("classOptions", this.classOptions);
      if (!classId || !this.classOptions) return "-";

      const grade = this.classOptions.find((c) => c.value === classId);
      return grade ? grade.text : "-";
    },

    editNotification(item) {
      if (!item.scheduledAt) return;

      const now = new Date();
      const scheduledTime = new Date(item.scheduledAt);

      if (scheduledTime <= now) {
        this.alertMessageToast = "You cannot edit a completed or past notification.";
        this.showToast("danger");
        return;
      }

      let localISO = "";
      if (item.scheduledAt) {
        const utcDate = new Date(item.scheduledAt);
        localISO = new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 60000)
          .toISOString()
          .slice(0, 16);
      }

      this.record = {
        title: item.title || "",
        message: item.message || "",
        mascort: item.mascort || "",
        whenTrigger: item.targetType || "",
        activeDuration: item.activeDuration || null,
        selectedClass: item.selectedClass || null,
        scheduled_at: localISO,
        specificUserIds: item.specificUserIds
          ? item.specificUserIds.join(",")
          : "",
        selectedCountry: item.country || "",
      };

      this.isEditing = true;
      this.editingId = item._id;
      this.$bvModal.show("add-app-notifications");
    },

    editRecord(notification) {
      this.record = { ...notification };
      this.isEditing = true;
      this.editingId = notification._id;
    },
    cancelEdit() {
      this.isEditing = false;
      this.editingId = null;
      this.record = null;
    },

    formatScheduleTime(isoString) {
      if (!isoString) return '-';
      const date = new Date(isoString);

      const options = {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      };

      return date
        .toLocaleString('en-US', options)
        .replace(/,(\s*)/g, ' ')
        .replace('  ', ' ');
    },


    getScheduleStatusText(item) {
      if (!item.scheduledAt) return '-';

      const scheduledTime = new Date(item.scheduledAt);
      const now = new Date();
      const diff = scheduledTime - now;

      if (diff > 60 * 1000) {
        return this.formatScheduleTime(item.scheduledAt);
      }

      if (Math.abs(diff) <= 60 * 1000) {
        return '⏳ Processing...';
      }

      if (item.status === 'completed') {
        return '✅ Sent';
      }

      return '-';
    },


    async fetchNotifications(page = 1) {
      this.show = true;
      try {
        const payload = { search: this.searchQuery };
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/get-push-notifications?page=${page}`,
          payload,
          { headers: { Authorization: this.bearerToken } }
        );

        this.pushNotification = res.data.notifications;

        this.pushNotification.data.forEach((n) => {
          n.statusCount = n.statusCount || { pending: 0, success: 0, failed: 0 };
          n.recipients = n.recipients || [];
        });

      } catch (err) {
        console.error("Failed to fetch notifications:", err);
      } finally {
        this.show = false;
      }
    },


    deleteNotification(item) {
      Swal.fire({
        title: "Are you sure?",
        text: `Do You want to delete the notification "${item.title}"!`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.delete(item._id)
        }
      });
    },

    showToast(variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Notification",
          icon: "BellIcon",
          text: this.alertMessageToast,
          variant,
        },
      });
    },


    async delete(notificationId) {
      if (!notificationId) return;

      this.loading = true;
      this.errorMsg = "";

      try {
        const resp = await axios.delete(
          `${process.env.VUE_APP_API_URL}/delete-push-notifications/${notificationId}`,
          {
            headers: {
              Authorization: this.bearerToken,
            },
          }
        );

        if (resp.data.success) {
          this.alertMessageToast = "Notification deleted successfully!";
          this.showToast("success");
          this.fetchNotifications();
        } else {
          this.errorMsg = resp.data.error || "Failed to delete notification";
          this.alertMessageToast = this.errorMsg;
          this.showToast("danger");
        }
      } catch (error) {
        if (error.response) {
          this.errorMsg = error.response.data.error || "An error occurred";
        } else if (error.request) {
          this.errorMsg =
            "No response received from server. Please check your network connection.";
        } else {
          this.errorMsg = "Error in request setup: " + error.message;
        }

        this.alertMessageToast = this.errorMsg;
        this.showToast("danger");
      } finally {
        this.loading = false;
      }
    },


    async viewFailedDetails(notificationId) {
      if (!notificationId) return;

      this.loading = true;
      this.failedUsers = [];

      try {
        const resp = await axios.get(
          `${process.env.VUE_APP_API_URL}/get-failed-notifications/${notificationId}`,
          {
            headers: {
              Authorization: this.bearerToken,
            },
          }
        );

        if (resp.data.success) {
          this.failedUsers = resp.data.data || [];
          this.$bvModal.show("failed-detail-modal");
        } else {
          this.alertMessageToast = resp.data.error || 'Error fetching failed notification details';
          this.showToast("danger");
        }
      } catch (error) {
        this.alertMessageToast = resp.data.error || 'Error fetching failed notification details';
        this.showToast("danger");
        console.error("Error fetching failed details:", error);

      } finally {
        this.loading = false;
      }
    },





  },
};
</script>
